import { render, staticRenderFns } from "./MasterRplPpak.vue?vue&type=template&id=39fa872a&"
import script from "./MasterRplPpak.vue?vue&type=script&lang=js&"
export * from "./MasterRplPpak.vue?vue&type=script&lang=js&"
import style0 from "./MasterRplPpak.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports